import validate from 'validate.js'
import mapValues from 'lodash/mapValues'
import keyBy from 'lodash/keyBy'

validate.options = {
  fullMessages: false,
}

export default function validateForm(
  fields,
  filledFields,
  locale = false,
) {
  const constraits = mapValues(
    keyBy(fields, 'name'),
    ({ validate: val }) => {
      // return val if exists and presence array not contains locale
      if (val) {
        // check if presence has countries
        if (val.presence && val.presence.countries) {
          // check if presence.countries has locale
          if (val.presence.countries.includes(locale)) {
            return val
          }
        } else {
          return val
        }
      }
      return {}
    },
  )
  return validate(filledFields, constraits) || {}
}
